import { BadgeCheck } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgValidationCheck = mkIcon(BadgeCheck);